import { render, staticRenderFns } from "./InformationChangePopup.vue?vue&type=template&id=660210d4&scoped=true"
import script from "./InformationChangePopup.vue?vue&type=script&lang=js"
export * from "./InformationChangePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660210d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('660210d4')) {
      api.createRecord('660210d4', component.options)
    } else {
      api.reload('660210d4', component.options)
    }
    module.hot.accept("./InformationChangePopup.vue?vue&type=template&id=660210d4&scoped=true", function () {
      api.rerender('660210d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/userDetails/components/InformationChangePopup.vue"
export default component.exports